module.exports = __webpack_public_path__ + "img/icon-eye-paid.7f5d5d50.svg";